import { render, staticRenderFns } from "./PrinterEdit.vue?vue&type=template&id=4cd5d468&"
import script from "./PrinterEdit.vue?vue&type=script&lang=ts&"
export * from "./PrinterEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports